module.exports = __webpack_public_path__ + "assets/e4d9f12faa1361b869f6ac5b8ed9fb38.png";